import moment from "moment";

export const calculateOverallStrength = (formDataArray) => {
  const totalForms = formDataArray.length;
  const totalStrength = formDataArray.reduce((sum, formData) => {
    const formStrength = calculateFormStrength(formData);
    return sum + formStrength;
  }, 0);

  const overallStrength = (totalStrength / totalForms) * 100;
  return overallStrength;
};

const calculateFormStrength = (formData) => {
  return Object.values(formData).reduce((sum, value) => sum + value, 0);
};

export const getMappedDates = (dateOption) => {
  const today = new Date();
  let startdate;

  if (dateOption == "1") {
    // For 1 day, get jobs from the last 24 hours
    startdate = moment(today)
      .subtract(1, "d")
      .startOf('day')
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
  } else if (dateOption == "3") {
    // For 3 days, get jobs from the last 3 days
    startdate = moment(today)
      .subtract(3, "d")
      .startOf('day')
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
  } else if (dateOption == "7") {
    // For 7 days, get jobs from the last 7 days
    startdate = moment(today)
      .subtract(7, "d")
      .startOf('day')
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
  } else if (dateOption == "30") {
    // For 30 days
    startdate = moment(today)
      .subtract(30, "d")
      .startOf('day')
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
  } else {
    startdate = null;
  }

  return startdate ? `[${startdate} TO NOW]` : "* TO *";
};


function splitBySpecialCharacters(input) {
  const specialCharRegex = /[^a-zA-Z0-9\s]+/;
  const parts = input.split(specialCharRegex);
  const cleanedParts = parts
    .map((part) => part.trim())
    .filter((part) => part !== "");
  return cleanedParts;
}

const removeItems = [
  "skill",
  "technology",
  "developer",
  "programmer",
  "architect",
  "designer",
  "consultant",
  "administrator",
  "coach",
  "lead",
  "manager",
  "master",
  "specalist",
  "modeler",
  "director",
  "hacker",
  "engineer",
  "analyst",
  "dba",
  "tester",
  "senior",
  "senior.",
  "sr",
  "junior",
  "junior.",
  "jr",
  "sr.",
  "jr.",
  "knowledge",
  "or",
  "with",
  "to",
  "and",
  "front",
  "end",
  "back",
  "full",
  "stack",
  "full stack",
  "basis",
];

export function processSearchTitle(title) {
  const wordRegex = /[^\W\d_]+/g;
  const words = title.match(wordRegex);
  // console.log('processSearchTitle words', words);

  if (words) {
    const filteredWords = words.filter(
      (word) => isNaN(word) && !removeItems.includes(word.toLowerCase())
    );
    const splittingSpecialCharacter = splitBySpecialCharacters(title);
    // console.log('processSearchTitle splittingSpecialCharacter', splittingSpecialCharacter);

    const finalTitleWords = filteredWords.concat(splittingSpecialCharacter);
    //  .map(word => `"${word}"`)
    //  .join(" OR ");
    const finalFilter = finalTitleWords
      .filter((word) => !removeItems.includes(word.toLowerCase()))
      .map((word) => `"${word}"`)
      .join(" OR ");
    // console.log('processSearchTitle finalTitleWords', finalTitleWords, finalFilter);

    return finalFilter;
  } else {
    return title;
  }
}